import React from 'react';
import styled from 'styled-components';
import ReactModal from 'react-modal';
import theme from 'theme/theme';
import { CloseIcon } from 'base/components/Icon/index';

const CloseButton = styled(CloseIcon)`
  position: absolute;
  top: 10px;
  left: 15px;
  font-size: 30px;
  transition: all ease-in-out 0.1s;
  &:hover {
    fill: ${theme.colors.primary};
    transform: scale(1.5);
  }
  @media (min-width: ${theme.breakpoints.desktop}) {
    font-size: 45px;
  }
  @media (min-width: ${theme.breakpoints.desktopLarge}) {
    top: 60px;
    left: auto;
    right: 60px;
    font-size: 40px;
  }
`;

ReactModal.setAppElement('#app');

const ReactModalAdapter = ({ className, modalClassName, name, children, onRequestClose, isClosable=true, ...other }) => ( // eslint-disable-line
  <ReactModal
    className={modalClassName}
    bodyOpenClassName={`ReactModal__Body--open modal-${name.toLowerCase().replace('_', '-')}`}
    portalClassName={className}
    onRequestClose={onRequestClose}
    closeTimeoutMS={200}
    shouldCloseOnOverlayClick={false}
    {...other}
  >
    {children}
    {isClosable && <CloseButton onClick={onRequestClose} />}
  </ReactModal>
);

const Modal = styled(ReactModalAdapter).attrs(() => ({
  overlayClassName: {
    base: 'Overlay',
    afterOpen: 'Overlay--after-open',
    beforeClose: 'Overlay--before-close',
  },
  modalClassName: {
    base: 'Modal',
    afterOpen: 'Modal--after-open',
    beforeClose: 'Modal--before-close',
  },
}))`
  .Overlay {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    justify-content: center;
    align-items: center;
    overflow: scroll;
    display: flex;
    padding: 25px;
    background-color: rgba(235, 235, 235, 0.5);
    transition: ${theme.transitions.all};
    // Scale transform leads to conflict with PSPDFKit, see BI-283
    // => disable scale transform until solution is found
    //transform: scale(2);
    transform: scale(1);
    opacity: 0;
    
    @media (min-width: ${theme.breakpoints.desktopLarge}) {
      padding: 55px;
    }
    
    &.Overlay--after-open {
      opacity: 1;
      transform: scale(1);
      transition-timing-function: ease-in;
    }
    
    &.Overlay--before-close {
      opacity: 0;
      // Scale transform leads to conflict with PSPDFKit, see BI-283
      // => disable scale transform until solution is found
      //transform: scale(2);
      transform: scale(1);
    }
  }
  
  .Modal {
    display: flex;
    flex-direction: column;
    align-self: baseline;
    outline: none;
    -webkit-overflow-scrolling: touch;
    margin: 0;
    max-width: 100%;
    width: 100%;
    padding: 50px;
    background: ${theme.colors.white};
    color: ${theme.colors.dark};
    @media (min-width: ${theme.breakpoints.desktopLarge}) {
      width: 100%;
      max-width: ${(props) => props.width};
      box-shadow: ${theme.shadows.default};
    }
  }
  
  &.fullscreen .Overlay,
  &.fullscreen .Modal {
    padding: 0;
  }
  
  &.fullscreen .Modal {
    height: 100%;
  }
  
  &.fullscreen ${CloseButton} {
    fill: ${theme.colors.white};
    &:hover {
      fill: ${theme.colors.white};
    }
    @media (min-width: ${theme.breakpoints.desktop}) {
      font-size: 30px; 
      top: 10px;
    }
    
    @media (min-width: ${theme.breakpoints.desktopLarge}) {
      font-size: 30px; 
      top: 10px;
      left: auto;
      right: 25px;
    }
  }
  
  &.flexModal .Modal {
    display: flex;
    flex-direction: column;
  }
  
`;
Modal.defaultProps = {
  width: '800px',
  name: '',
};
export default Modal;
